import React, { useMemo } from "react";
import CustomTable from "components/Table/CustomTable";
import { AffiliatesSchema } from "model/dashboard/affiliates.schema";
import { formatCurrency } from "utils/formatters";
import useTableChangeHandler from "hooks/useTableChangeHandler";
import Avatar from "components/Avatar/Avatar";
const AffiliateTable = ({ data, error, isLoading, onTableChange }) => {
  // HOOK CHANGE
  const { handleSort, handleFilter, handleSearch, handlePageChange } = useTableChangeHandler(onTableChange);

  // COLUMN
  const columns = useMemo(
    () => [
      {
        header: "Affiliate พาร์ทเนอร์",
        accessor: "firstName",
        sortable: true,
        render: (item) => (
          <div className="partner-info d-flex align-items-center gap-3">
            <Avatar src={item.profilePicture} alt={`${item.firstName} ${item.lastName}`} />
            <div>
              <div className="text-lg fw-semibold">{`${item.firstName} ${item.lastName}`}</div>
              <div className="text-md text-gray-500">{item.email}</div>
            </div>
          </div>
        ),
      },
      {
        header: "จำนวนลิงค์ที่สร้างไว้",
        accessor: "links",
        sortable: true,
        responsive: "lg",
        render: (item) => item.stats.links,
      },
      {
        header: "จำนวนการคลิก",
        accessor: "clicks",
        sortable: true,
        responsive: "md",
        render: (item) => item.stats.clicks,
      },
      {
        header: "Unique Clicks",
        accessor: "uniques",
        sortable: true,
        responsive: "md",
        render: (item) => item.stats.uniques,
      },
      {
        header: "ยอดขายทั้งหมด",
        accessor: "sales",
        sortable: true,
        align: "end",
        render: (item) => <div className="fw-semibold">{formatCurrency(item.stats.sales)}</div>,
      },
      {
        header: "รายได้ทั้งหมด",
        accessor: "earnings",
        sortable: true,
        align: "end",
        render: (item) => <div className="text-primary-600 fw-semibold">{formatCurrency(item.stats.earnings)}</div>,
      },
    ],
    []
  );

  // RENDER
  return (
    <div data-testid="affiliate-table">
      <div className="text-lg mb-4">รายการพาร์ทเนอร์ Affiliate ทั้งหมดในระบบ *{data?.pagination?.total?.toLocaleString() || 0} ผู้ใช้งาน*</div>

      <CustomTable columns={columns} data={data?.data || []} itemsPerPage={data?.pagination?.limit || 10} totalItems={data?.pagination?.total || 0} className="affiliate-table" onSort={handleSort} onFilter={handleFilter} onSearch={handleSearch} onPageChange={handlePageChange} status={isLoading ? "loading" : error ? "error" : data?.data?.length === 0 ? "empty" : "normal"} errorMessage={error?.message || "เกิดข้อผิดพลาดในการโหลดข้อมูล"} emptyMessage="ไม่พบข้อมูลพาร์ทเนอร์ Affiliate" />
    </div>
  );
};

const withYupValidation = (WrappedComponent, schema) => {
  return function WithYupValidation(props) {
    try {
      if (!props.isLoading && !props.error && props.data) {
        schema.validateSync(props.data);
      }
      return <WrappedComponent {...props} />;
    } catch (error) {
      return (
        <div className="alert alert-danger">
          <strong>Validation Error:</strong> {error.message}
        </div>
      );
    }
  };
};

const ValidatedTable = withYupValidation(AffiliateTable, AffiliatesSchema);

export default ValidatedTable;
